import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { EpdkTabNavBarComponent } from './tab-nav-bar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatTabsModule
  ],
  declarations: [EpdkTabNavBarComponent],
  exports: [EpdkTabNavBarComponent]
})
export class EpdkTabNavBarModule { }